import { AgmCoreModule } from '@agm/core';
import { AutoCompleteModule } from 'primeng/components/autocomplete/autocomplete';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
// import { Http, HttpModule, RequestOptions, XHRBackend } from '@angular/http';
import { HttpModule, RequestOptions } from '@angular/http';
import { NgbModalModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';
import { Ng2CableModule } from 'ng2-cable';
import { RouterModule, PreloadAllModules }   from '@angular/router';
import { appRoutes } from './app.routes';
import * as $ from 'jquery';
import { TextMaskModule } from 'angular2-text-mask';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { UtilsModule } from '../components/+utils/utils.module';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

import {
  AddressService,
  Authentication,
  CampusService,
  CampusAddressService,
  CardsService,
  CartService,
  ConfirmationsService,
  ConversationsService,
  FavoriteService,
  GooglePlacesService,
  MenuCategoriesService,
  MenuItemService,
  MessagesService,
  OptionVariantsService,
  OrderCheckoutService,
  OrderItemService,
  OrderPlaceService,
  OrderService,
  PhotosService,
  ReviewService,
  RequestOptionsInterceptor,
  RestaurantOrderService,
  RestaurantService,
  ZipRequestsService
} from '../providers';
import { SECRETS } from '../constants';
import { ValidationService } from '../services';
import { AppComponent } from './app.component';

import { AddressSearchComponent } from '../components/address_search/address_search';
import { FooterComponent } from '../components/footer/footer';
import { HeaderComponent } from '../components/header/header';
import { HomeComponent } from '../components/home/home';
import { AssistantComponent } from '../components/assistant/assistant';
import { MessengerModalComponent } from '../components/messenger_modal/messenger_modal';
import { SigninComponent } from '../components/signin/signin';
import { SignupComponent } from '../components/signup/signup';
import { ForgotPasswordComponent } from '../components/forgot_password/forgot_password';

@NgModule({
  declarations: [
    AppComponent,
    AddressSearchComponent,
    AssistantComponent,
    FooterComponent,
    HeaderComponent,
    HomeComponent,
    MessengerModalComponent,
    SigninComponent,
    SignupComponent,
    ForgotPasswordComponent,
  ],
  entryComponents: [
    ForgotPasswordComponent,
    MessengerModalComponent,
    SigninComponent
  ],
  imports: [
    AgmCoreModule.forRoot({
       apiKey: SECRETS.google_api_key,
       libraries: ['places']
     }),
    AutoCompleteModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    LazyLoadImageModule,
    NgbModalModule.forRoot(),
    ReactiveFormsModule,
    RouterModule.forRoot(appRoutes, {
      useHash: Boolean(history.pushState) === false,
      preloadingStrategy: PreloadAllModules
    }),
    Ng2CableModule,
    ScrollToModule.forRoot(),
    TextMaskModule,
    ToastModule.forRoot(),
    UtilsModule
  ],
  providers: [
    AddressService,
    Authentication,
    CampusService,
    CampusAddressService,
    CardsService,
    CartService,
    ConfirmationsService,
    ConversationsService,
    FavoriteService,
    GooglePlacesService,
    MenuCategoriesService,
    MenuItemService,
    MessagesService,
    NgbActiveModal,
    OptionVariantsService,
    OrderCheckoutService,
    OrderItemService,
    OrderPlaceService,
    OrderService,
    PhotosService,
    RestaurantOrderService,
    RestaurantService,
    ReviewService,
    ValidationService,
    ZipRequestsService,
    { provide: RequestOptions, useClass: RequestOptionsInterceptor },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts